const contactCustomerConstants = {
  CUSTOMER_CARE_SUBMIT_FORM_SUCCESS: "CUSTOMER_CARE_SUBMIT_FORM_SUCCESS",
  CUSTOMER_CARE_SUBMIT_FORM_ATTEMPT: "CUSTOMER_CARE_SUBMIT_FORM_ATTEMPT",
  CUSTOMER_CARE_SUBMIT_FORM_FAILED: "CUSTOMER_CARE_SUBMIT_FORM_FAILED",
  CUSTOMER_CARE_SUBMIT_FORM_RESET: "CUSTOMER_CARE_SUBMIT_FORM_RESET",
  MAX_MESSAGE_CHARS_ALLOWED: 200,
}

export default contactCustomerConstants
